<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
				<div class="card">
					<div class="card-header bg-info text-white">Listado</div>
					<div class="table-responsive">
						<table class="m-0 table table-condensed table-striped">
							<thead>
								<tr>
									<th colspan="3">
										<button class="btn btn-sm" :class="(tipo === 'cuentas') ? 'btn-primary' : 'btn-default'" @click="setTipo('cuentas')">
											Cuentas
										</button>
										<button class="btn btn-sm" :class="(tipo === 'alias') ? 'btn-primary' : 'btn-default'" @click="setTipo('alias')">
											Alias
										</button>
									</th>
								</tr>
							</thead>
							<thead>
								<tr>
									<th colspan="3">
										<button class="btn btn-sm btn-primary" v-if="tipo === 'cuentas'" @click="nuevaCuenta">
											<span class="fa fa-plus mr-2"></span>
											Nueva cuenta
										</button>

										<button class="btn btn-sm btn-primary" v-if="tipo === 'alias'" @click="nuevoAlias">
											<span class="fa fa-plus mr-2"></span>
											Nuevo alias
										</button>
									</th>
								</tr>
							</thead>
							<!-- CUENTAS -->
							<tbody v-if="tipo === 'cuentas'">
								<tr v-for="cuenta in listadoCuentas" :key="cuenta.cuenta+cuenta.dominio_id">
									<td style="vertical-align:middle;width:30px;text-align:center;">
										<span class="fa fa-envelope"></span>
									</td>
									<td>
										{{cuenta.email}}
										<br>
										<span style="opacity:0.6;" v-if="cuenta.usuario">
											Asignada a <b>{{cuenta.usuario.nombre}} {{cuenta.usuario.apellidos}}</b>
										</span>
										<span style="opacity:0.6;" v-if="!cuenta.usuario">
											No asignada a nadie
										</span>
									</td>
									<td class="text-right" style="vertical-align:middle;">
										<button class="btn btn-sm btn-primary" @click="editarCuenta(cuenta.id)">
											<span class="fa fa-edit"></span>
										</button>
									</td>
								</tr>
							</tbody>

							<!-- ALIAS -->
							<tbody v-if="tipo === 'alias'">
								<tr v-for="alias in listadoAlias" :key="alias.aliasOrigen">
									<td style="vertical-align:middle;width:30px;text-align:center;">
										<span class="fa fa-reply-all"></span>
									</td>
									<td>
										{{alias.aliasOrigen}}
									</td>
									<td class="text-right" style="vertical-align:middle;">
										<button class="btn btn-sm btn-primary" @click="editarAlias(alias)">
											<span class="fa fa-edit"></span>
										</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
				<editor-cuenta :id-cuenta="cuenta" v-if="cuenta" @update="getCuentas()"></editor-cuenta>
				<editor-alias :alias.sync="editandoAlias" v-if="editandoAlias" @update="getAlias()"></editor-alias>
			</div>
		</div>
	</div>
</template>

<script>
import API from './api'
import EditorCuentas from './editor-cuentas'
import EditorAlias from './editor-alias'
export default {
	components: {
		'editor-cuenta': EditorCuentas,
		'editor-alias': EditorAlias
	},
	data () {
		return {
			tipo: 'cuentas',
			cuenta: null,
			listadoCuentas: [],
			listadoAlias: [],
			editandoAlias: null
		}
	},

	created () {
		this.getCuentas()
	},

	methods: {
		nuevaCuenta () {
			this.cuenta = 'nueva'
		},
		editarCuenta (id) {
			this.cuenta = id
			this.$forceUpdate()
		},
		nuevoAlias () {
			this.editandoAlias = 'nuevo'
		},
		editarAlias (alias) {
			this.editandoAlias = {
				cuenta: alias.origen,
				dominio: alias.dominio_origen
			}
		},
		setTipo (tipo) {
			this.tipo = tipo

			if (tipo === 'cuentas') {
				this.getCuentas()
			} else {
				this.getAlias()
			}
		},

		getCuentas () {
			API.getCuentas()
				.then(res => {
					this.listadoCuentas = res.data.cuentas
					this.listadoAlias = []
					this.editandoAlias = false
				})
				.catch(this.error)
		},

		getAlias () {
			API.getAliases()
				.then(res => {
					this.listadoAlias = res.data.alias
					this.cuenta = null
					this.listadoCuentas = []
				})
				.catch(this.error)
		},

		error (e) {
			this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: e.response.data.error
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-cuentas-email/vue/app.vue